import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

/** site-information — registry field list. */
export const SITE_INFORMATION_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    'site-information',
    'siteDimensions',
    0,
    'siteDataCenterFlooring',
    'Data center flooring (raised floor)?',
    'Flooring',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    1,
    'siteWeightSupportOfFloor',
    'Weight support of floor [lbs/sqft]',
    'Weight',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    2,
    'siteRaisedFloorHeight',
    'Height of raised floor [in]',
    'Raised floor',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    3,
    'siteCeilingHeight',
    'Ceiling height [ft]',
    'Ceiling',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    4,
    'siteDroppedCeilingHeight',
    'Dropped ceiling height [ft]',
    'Dropped',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    5,
    'sitePlenumHeight',
    'If dropped ceiling, plenum height [ft]',
    'Plenum',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    6,
    'siteSlabToDroppedCeilingHeight',
    'Slab to dropped ceiling height [ft]',
    'Slab-ceiling',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    7,
    'siteRoomLengthFtIn',
    'Room length [ft]',
    'Length',
  ),
  defineField(
    'site-information',
    'siteDimensions',
    8,
    'siteRoomWidthSqftSqm',
    'Room width [ft]',
    'Width',
  ),
  defineField(
    'site-information',
    'additionalInformation',
    0,
    'siteAdditionalSizeInformation',
    'Additional Size Info',
    'Notes',
  ),
];
